import { render, staticRenderFns } from "./DestinationParams.vue?vue&type=template&id=5a3d722a&"
import script from "./DestinationParams.vue?vue&type=script&lang=js&"
export * from "./DestinationParams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports